import React from "react";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ModalMessage,
  ButtonGroup,
  CancelButton,
  ConfirmButton,
  Row,
} from "./ConfirmationModal.styles";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonType = "danger",
  isLoading = false,
}) => {
  useLockBodyScroll(isOpen);

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3600 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <ModalTitle>{title}</ModalTitle>
            <CloseButton onClick={handleCancel}>
              <CloseSvg width={20} height={20} />
            </CloseButton>
          </Row>
          <ModalMessage>{message}</ModalMessage>

          <ButtonGroup>
            <CancelButton onClick={handleCancel} disabled={isLoading}>
              {cancelText}
            </CancelButton>
            <ConfirmButton
              onClick={handleConfirm}
              $type={confirmButtonType}
              disabled={isLoading}
            >
              {isLoading ? (
                <l-line-spinner size="20" stroke="2" speed="1" color="#fff" />
              ) : (
                confirmText
              )}
            </ConfirmButton>
          </ButtonGroup>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default ConfirmationModal;
